// Columnas de las tablas de Matrículas. Los ids coinciden con el catálogo del backend
// (apis-node: src/features/matriculas/matriculas.tabla.js). Generado a partir de él: si se
// añade una columna allí, se regenera aquí (el backend rechaza ids que no conozca).

export const COLUMNAS_SOLICITUDES = [
  {
    id: 'num_matricula',
    label: 'Número matrícula',
    width: 130,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Matrícula',
  },
  {
    id: 'empresaId',
    label: 'Empresa',
    width: 120,
    sortable: true,
    filter: 'multi',
    group: 'Matrícula',
  },
  {
    id: 'fecha',
    label: 'Fecha',
    width: 150,
    sortable: true,
    filter: 'date',
    group: 'Fechas',
    hora: true,
  },
  {
    id: 'fechaConfirmacion',
    label: 'Fecha confirmación',
    width: 160,
    sortable: true,
    filter: 'date',
    group: 'Fechas',
    hora: true,
  },
  {
    id: 'fechaBaja',
    label: 'Fecha baja',
    width: 130,
    sortable: true,
    filter: 'date',
    group: 'Fechas',
    hora: true,
  },
  { id: 'nombre', label: 'Nombre', width: 150, sortable: true, filter: 'text', group: 'Alumno' },
  {
    id: 'apellidos',
    label: 'Apellidos',
    width: 190,
    sortable: true,
    filter: 'text',
    group: 'Alumno',
  },
  {
    id: 'dni',
    label: 'DNI',
    width: 120,
    sortable: true,
    filter: 'text',
    defaultVisible: false,
    group: 'Alumno',
  },
  {
    id: 'email',
    label: 'Email',
    width: 240,
    sortable: true,
    filter: 'text',
    defaultVisible: false,
    group: 'Alumno',
  },
  {
    id: 'nombre_grupo',
    label: 'Grupo',
    width: 200,
    sortable: true,
    filter: 'multi',
    group: 'Académico',
  },
  {
    id: 'centro',
    label: 'Centro',
    width: 190,
    sortable: true,
    filter: 'multi',
    group: 'Académico',
  },
  { id: 'ciclo', label: 'Ciclo', width: 240, sortable: true, filter: 'multi', group: 'Académico' },
  { id: 'curso', label: 'Tipo', width: 130, sortable: true, filter: 'multi', group: 'Académico' },
  {
    id: 'anyo',
    label: 'Año escolar',
    width: 110,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Académico',
  },
  {
    id: 'estado',
    label: 'Estado',
    width: 160,
    sortable: true,
    filter: 'multi',
    group: 'Matrícula',
  },
  { id: 'actions', label: 'Acciones', width: 72, fixed: true },
];

export const COLUMNAS_MATRICULAS_MODULOS = [
  {
    id: 'id',
    label: 'ID línea',
    width: 100,
    sortable: true,
    filter: 'text',
    align: 'right',
    defaultVisible: false,
    group: 'Matrícula',
  },
  {
    id: 'empresaId',
    label: 'Empresa',
    width: 120,
    sortable: true,
    filter: 'multi',
    group: 'Matrícula',
  },
  {
    id: 'num_matricula',
    label: 'Número matrícula',
    width: 130,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Matrícula',
  },
  {
    id: 'modulo',
    label: 'Módulo / asignatura',
    width: 300,
    sortable: true,
    filter: 'multi',
    group: 'Académico',
  },
  {
    id: 'codigoOficial',
    label: 'Código oficial',
    width: 130,
    sortable: true,
    filter: 'multi',
    group: 'Académico',
  },
  {
    id: 'codigoModulo',
    label: 'Código interno',
    width: 170,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Académico',
  },
  { id: 'ciclo', label: 'Ciclo', width: 240, sortable: true, filter: 'multi', group: 'Académico' },
  {
    id: 'horas',
    label: 'Horas',
    width: 90,
    sortable: true,
    filter: 'text',
    align: 'right',
    defaultVisible: false,
    group: 'Académico',
  },
  {
    id: 'creditos',
    label: 'Créditos',
    width: 100,
    sortable: true,
    filter: 'text',
    align: 'right',
    defaultVisible: false,
    group: 'Académico',
  },
  { id: 'nombre', label: 'Nombre', width: 150, sortable: true, filter: 'text', group: 'Alumno' },
  {
    id: 'apellidos',
    label: 'Apellidos',
    width: 190,
    sortable: true,
    filter: 'text',
    group: 'Alumno',
  },
  {
    id: 'dni',
    label: 'DNI',
    width: 120,
    sortable: true,
    filter: 'text',
    defaultVisible: false,
    group: 'Alumno',
  },
  {
    id: 'email',
    label: 'Email',
    width: 240,
    sortable: true,
    filter: 'text',
    defaultVisible: false,
    group: 'Alumno',
  },
  {
    id: 'nombre_grupo',
    label: 'Grupo',
    width: 200,
    sortable: true,
    filter: 'multi',
    group: 'Académico',
  },
  {
    id: 'centro',
    label: 'Centro',
    width: 190,
    sortable: true,
    filter: 'multi',
    group: 'Académico',
  },
  {
    id: 'curso',
    label: 'Tipo',
    width: 130,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Académico',
  },
  {
    id: 'anyo',
    label: 'Año escolar',
    width: 110,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Académico',
  },
  {
    id: 'estado',
    label: 'Estado matrícula',
    width: 160,
    sortable: true,
    filter: 'multi',
    group: 'Matrícula',
  },
  {
    id: 'fecha',
    label: 'Fecha matrícula',
    width: 150,
    sortable: true,
    filter: 'date',
    defaultVisible: false,
    group: 'Fechas',
    hora: true,
  },
  {
    id: 'fechaBajaModulo',
    label: 'Baja del módulo',
    width: 140,
    sortable: true,
    filter: 'date',
    defaultVisible: false,
    group: 'Fechas',
  },
  {
    id: 'fechaBaja',
    label: 'Baja de la matrícula',
    width: 150,
    sortable: true,
    filter: 'date',
    defaultVisible: false,
    group: 'Fechas',
  },
  { id: 'actions', label: 'Acciones', width: 72, fixed: true },
];

export const TABLA_SOLICITUDES = 'solicitudes';
export const TABLA_MATRICULAS_MODULOS = 'matriculas-modulos';
